import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { GenericService } from '../generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { LoginRequest, UserRightsService } from '../user-rights/user-rights.service';
import { User } from '@huge-monorepo/portal/models';
import { Routes } from '@huge-monorepo/portal/config';
import { ICustomerLoginService } from '@huge-monorepo/shared/interfaces';
import { catchError, EMPTY, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginService implements ICustomerLoginService {
  constructor(
    private genericService: GenericService,
    private userRightsService: UserRightsService,
    private auth: UserRightsService,
    private routes: Routes,
    private endpoints: Endpoints,
    private toastService: ToastrService,
    private router: Router,
  ) { }

  LoginRequest(obj: any, isCustomer = true): Observable<{ success: boolean; error?: string }> {
    return this.genericService.POST(this.endpoints.LOGIN, obj, false).pipe(
      map((resp) => {
        const loginResult = resp['body'];
        const user = loginResult['user'] as User;

        this.userRightsService.SetRights(user.UserAccessRoles!);

        if (loginResult['token']) {
          const loginRequest = new LoginRequest(
            loginResult['user']['ID'],
            0,
            loginResult['user']['UserID'],
            loginResult['user']['Email'],
            loginResult['user']['Name'],
            loginResult['token'],
            loginResult['user']['GroupID'],
            loginResult['user']['GroupName'],
            loginResult['user']['KeepAliveAccess'],
            loginResult['user']['CDRAccess'],
            loginResult['user']['MikrotikAccess'],
            loginResult['user']['RelayAccess'],
            loginResult['user']['UserAccessRoles'],
            loginResult['user']['ImpersonatedUserAccessRoles'],
            loginResult['user']['ImpersonatedUser'],
            loginResult['user']['HugeAdmin'],
            loginResult['user']['KeepAliveTypes'],
            loginResult['user']['PortalReadAccess'],
            loginResult['user']['PortalWriteAccess'],
            false,
            null,
            null,
            null,
            loginResult['user']['TeltonikaAccess'],
            loginResult['user']['ContractorsAccess'],
          );
          loginRequest.DefaultGroupID = loginResult['user']['DefaultGroupID'];
          loginRequest.IsAggregated = loginResult['user']['IsAggregated'];

          const loginSuccess = this.auth.Login(loginRequest);

          if (loginSuccess) {
            const accessObject = this.auth.GetUserAccessRoles();
            if (!accessObject?.IsPortalUser()) {
              this.toastService.error('', 'You do not have the required access to the portal', {
                timeOut: 10000,
              });
              this.auth.Logout();
              return { success: false, error: 'no_access' };
            }

            if (!(this.auth.HasCDRAccess() || this.auth.HasKeepAliveAccess() || this.auth.HasRelayAccess() || this.auth.HasMikrotikAccess() || this.auth.HasContractorsAccess() || this.auth.HasTeltonikaAccess())) {
              this.toastService.error('', 'Your group does not have any permissions set up', {
                timeOut: 10000,
              });
              this.auth.Logout();
              return { success: false, error: 'no_permissions' };
            }

            setTimeout(() => {
              window.location.replace(this.routes.Home);
            });
            this.toastService.success(user.Name.toString(), 'Welcome to the Huge Customer Portal.', { timeOut: 4000 });
            return { success: true };
          } else {
            this.toastService.error('Contact a system administrator for help', 'Login Unsuccessful', {
              timeOut: 4000,
            });
            return { success: false, error: 'login_failed' };
          }
        } else {
          return { success: false, error: 'incorrect' };
        }
      }),
      catchError((error) => {
        return [{ success: false, error: 'incorrect' }];
      }),
    );
  }

  ForgotPasswordRequest(user: User): Observable<void> {
    return this.genericService.POST(this.endpoints.FORGOT_PASSWORD, user, false).pipe(
      map((loginResult) => {
        if (loginResult == null) {
          this.toastService.success('', 'Please see your registered email account for the reset link. This might take a few minutes.', { timeOut: 3000 });
          this.router.navigate(['/']);
        }
      }),
      catchError((error) => {
        this.toastService.error('', 'Password reset email failed to send, please contact the support team for assistance.', { timeOut: 3000 });
        return EMPTY;
      }),
    );
  }

  ResetPasswordRequest(obj: any, password: string): Observable<void> {
    return this.genericService.POST(this.endpoints.RESET_PASSWORD_PRK(obj), { password }, false).pipe(
      map(() => {
        this.toastService.success(
          '',
          'Please login with your email address and new password.',
          { timeOut: 3000 }
        );
        this.router.navigate(['/']);
      }),
      catchError((error) => {
        this.toastService.error(
          '',
          'Password reset failed, please contact support for assistance.',
          { timeOut: 3000 }
        );
        return EMPTY;
      })
    );
  }
}
